"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8220],{

/***/ 26945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15722);


var StoreSchedule = function(param) {
    var schedule = param.schedule;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (0,_lib_helpers__WEBPACK_IMPORTED_MODULE_1__/* .getStoreCombinedSchedule */ .ne)(schedule).map(function(day, index) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "mr-1",
                        children: day.endDay ? "".concat(day.startDay, " — ").concat(day.endDay, ": ") : "".concat(day.startDay, ": ")
                    }),
                    day.openHours
                ]
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StoreSchedule);


/***/ }),

/***/ 78220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductStoreAvailability_StoreSelectModal; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 10 modules
var es = __webpack_require__(26209);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Modal.js
var Modal = __webpack_require__(12280);
// EXTERNAL MODULE: ./components/ProductPage/ProductStoreAvailability/StoresFilters.js
var StoresFilters = __webpack_require__(57924);
// EXTERNAL MODULE: ./components/ProductPage/ProductStoreAvailability/StoresList.js
var StoresList = __webpack_require__(53641);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
// EXTERNAL MODULE: ./components/ProductPage/ProductStoreAvailability/StoreSchedule.js
var StoreSchedule = __webpack_require__(26945);
// EXTERNAL MODULE: ./components/ProductPage/ProductStoreAvailability/StoreSpecialSchedule.js
var StoreSpecialSchedule = __webpack_require__(23880);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(52077);
;// CONCATENATED MODULE: ./components/ProductPage/ProductStoreAvailability/StoreSelectModal/StoreSelectModalStoreCard.js





var ref = (0,config["default"])(), settings = ref.publicRuntimeConfig.settings;
var StoreSelectModalStoreCard = function(param) {
    var storeData = param.storeData, onStoreSelect = param.onStoreSelect, selectedStoreId = param.selectedStoreId;
    var hasSpecialSchedule = Boolean(storeData.special_schedule);
    var isSelectedStore = selectedStoreId === storeData.id;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col md:flex-row md:justify-between md:items-center gap-[20px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-[14px]",
                children: [
                    (storeData === null || storeData === void 0 ? void 0 : storeData.name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "capitalize font-medium ",
                        children: storeData.name
                    }),
                    storeData.address && storeData.address,
                    hasSpecialSchedule ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSpecialSchedule/* default */.Z, {
                        schedule: storeData.special_schedule
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSchedule/* default */.Z, {
                        schedule: storeData.schedule
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "".concat(settings.baseUrl, "/magazine/").concat(storeData.url_key, "/"),
                        rel: "noopener noreferrer",
                        target: "_blank",
                        className: "text-red-brand hover:text-bleu-hover underline",
                        title: "",
                        children: "Vezi harta"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col md:flex-row gap-[10px] md:gap-[20px] min-w-fit",
                children: isSelectedStore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Selectat",
                    variant: "third",
                    size: "small",
                    classesProp: "pointer-events-none"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    title: "Selecteaza magazinul",
                    onClick: function() {
                        return onStoreSelect(storeData);
                    },
                    size: "small",
                    classesProp: "min-w-fit"
                })
            })
        ]
    }));
};
/* harmony default export */ var StoreSelectModal_StoreSelectModalStoreCard = (StoreSelectModalStoreCard);

// EXTERNAL MODULE: ./store/user/actions.js
var actions = __webpack_require__(49865);
// EXTERNAL MODULE: ./store/stores/actions.js
var stores_actions = __webpack_require__(76208);
// EXTERNAL MODULE: ./components/Loading.js
var Loading = __webpack_require__(24461);
// EXTERNAL MODULE: ./lib/sortedStores.js
var sortedStores = __webpack_require__(35254);
// EXTERNAL MODULE: ./lib/filterStores.js
var filterStores = __webpack_require__(19626);
// EXTERNAL MODULE: ./components/Alert.js + 10 modules
var Alert = __webpack_require__(16479);
;// CONCATENATED MODULE: ./components/ProductPage/ProductStoreAvailability/StoreSelectModal/index.js














function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var StoreSelectModal = function(param1) {
    var onStoreSelect = param1.onStoreSelect, selectedStore = param1.selectedStore, stores = param1.stores, regions = param1.regions, getStores1 = param1.getStores, getRegions1 = param1.getRegions;
    var storesData = (0,react.useMemo)(function() {
        return (0,sortedStores/* default */.Z)({
            storesData: stores,
            stickyStore: selectedStore
        });
    }, [
        stores,
        selectedStore
    ]);
    var ref = (0,react.useState)(), regionIdFilter = ref[0], setRegionIdFilter = ref[1];
    var ref1 = (0,react.useState)(""), storeNameFilter = ref1[0], setStoreNameFilter = ref1[1];
    var ref2 = (0,react.useState)(true), isLoading = ref2[0], setIsLoading = ref2[1];
    (0,react.useEffect)(function() {
        var fetchData = function() {
            var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
                var promises;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            promises = [];
                            if (!regions) {
                                promises.push(getRegions1());
                            }
                            if (!stores) {
                                promises.push(getStores1());
                            }
                            if (!promises.length) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 7;
                            return Promise.all(promises);
                        case 7:
                            setIsLoading(false);
                        case 8:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    var handleFiltersChange = function(param) {
        var regionId = param.regionId, storeSearch = param.storeSearch;
        if (regionId !== regionIdFilter) {
            setRegionIdFilter(regionId);
        }
        if (storeSearch && storeSearch.length > 2) {
            setStoreNameFilter(storeSearch);
        } else if (!storeSearch || storeSearch.length <= 2) {
            setStoreNameFilter("");
        }
    };
    var filteredStores = (0,filterStores/* default */.Z)({
        storesData: storesData,
        regionId: regionIdFilter,
        storeName: storeNameFilter
    });
    var hasStores = filteredStores.length > 0;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Modal["default"], {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "text-[18px]",
            children: "Magazin favorit"
        }),
        id: "StoreSelectModal",
        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
            height: 100
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresFilters/* default */.Z, {
                    regions: regions,
                    onFiltersChange: handleFiltersChange
                }),
                hasStores ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StoresList/* default */.Z, {
                    storesData: filteredStores,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StoreSelectModal_StoreSelectModalStoreCard, {
                        onStoreSelect: onStoreSelect,
                        selectedStoreId: selectedStore === null || selectedStore === void 0 ? void 0 : selectedStore.id
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-[20px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                        type: "error",
                        showIcon: true,
                        children: "Nu am gasit un magazin care sa indeplineasca criteriile filtrelor selectate."
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var ProductStoreAvailability_StoreSelectModal = ((0,es/* connect */.$j)(function(state) {
    return {
        regions: state.user.regions,
        stores: state.stores.data
    };
}, {
    getRegions: actions/* getRegions */.JL,
    getStores: stores_actions/* getStores */.r8
})(StoreSelectModal));


/***/ }),

/***/ 23880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash_every__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(711);
/* harmony import */ var lodash_every__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_every__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var date_fns_parse__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35337);
/* harmony import */ var date_fns_isValid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12274);
/* harmony import */ var date_fns_compareAsc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49474);
/* harmony import */ var date_fns_closestIndexTo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85573);
/* harmony import */ var date_fns_add__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29422);
/* harmony import */ var date_fns_locale_ro__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88397);








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var StoreSpecialSchedule = function(param1) {
    var schedule1 = param1.schedule;
    // TODO: We should use setDefaultOptions to set global defaults for date-fns
    var currentDate = new Date();
    var scheduleDateFormat = "d MMMM";
    var scheduleDateParseOptions = {
        locale: date_fns_locale_ro__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
    };
    var parsedSchedule = Object.entries(schedule1).map(function(param) {
        var _param = _slicedToArray(param, 2), date = _param[0], openHours = _param[1];
        var dateObject;
        var isValidDate = false;
        try {
            // The schedule date doesn't contain the year
            // Use the current year to set year context
            var currentYearScheduleDate = (0,date_fns_parse__WEBPACK_IMPORTED_MODULE_3__["default"])(date, scheduleDateFormat, currentDate, scheduleDateParseOptions);
            isValidDate = (0,date_fns_isValid__WEBPACK_IMPORTED_MODULE_4__["default"])(currentYearScheduleDate);
            if (isValidDate) {
                // Guess the schedule date year
                var nextYearScheduleDate = (0,date_fns_add__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(currentYearScheduleDate, {
                    years: 1
                });
                dateObject = (0,date_fns_closestIndexTo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(currentDate, [
                    currentYearScheduleDate,
                    nextYearScheduleDate, 
                ]) === 0 ? currentYearScheduleDate : nextYearScheduleDate;
            }
        } catch (error) {
            ;
        }
        return {
            date: date,
            openHours: openHours,
            dateObject: dateObject,
            isValidDate: isValidDate
        };
    });
    var isValidSchedule = lodash_every__WEBPACK_IMPORTED_MODULE_1___default()(parsedSchedule, function(schedule) {
        return schedule.isValidDate;
    });
    var sortedSchedule = isValidSchedule && parsedSchedule.sort(function(scheduleA, scheduleB) {
        return (0,date_fns_compareAsc__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(scheduleA.dateObject, scheduleB.dateObject);
    });
    if (!isValidSchedule) return null;
    return sortedSchedule.map(function(param, index) {
        var date = param.date, openHours = param.openHours;
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "mr-1",
                    children: [
                        date,
                        ":"
                    ]
                }),
                " ",
                openHours
            ]
        }, index);
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StoreSpecialSchedule);


/***/ }),

/***/ 57924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var react_final_form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66688);
/* harmony import */ var _components_Form_InputText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58833);
/* harmony import */ var _components_Form_Select__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66569);





var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_1__["default"])(), _publicRuntimeConfig = ref.publicRuntimeConfig, websiteTitle = _publicRuntimeConfig.content.websiteTitle;
var StoresFilters = function(param1) {
    var regions = param1.regions, onFiltersChange = param1.onFiltersChange;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
        onSubmit: function() {
            return null;
        },
        initialValues: {
            regionId: "",
            storeSearch: ""
        },
        render: function() {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("form", {
                className: "flex flex-col md:flex-row gap-[20px] md:max-w-[80%]",
                onSubmit: function(event) {
                    return event.preventDefault();
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .FormSpy */ .lP, {
                        onChange: function(param) {
                            var values = param.values;
                            return onFiltersChange(values);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col flex-grow",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                            label: "Magazinele ".concat(websiteTitle, " din"),
                            name: "regionId",
                            component: _components_Form_Select__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                            placeholder: "Toate regiunile",
                            inputClassName: "!max-w-full",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                    value: "",
                                    children: "Toate regiunile"
                                }),
                                (regions === null || regions === void 0 ? void 0 : regions.length) && regions.map(function(region) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                        value: region.id,
                                        children: region.name
                                    }, region.id);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex flex-col flex-grow",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_final_form__WEBPACK_IMPORTED_MODULE_2__/* .Field */ .gN, {
                            label: "Cauta magazin",
                            name: "storeSearch",
                            component: _components_Form_InputText__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                            placeholder: "Cauta magazin...",
                            inputClassName: "!max-w-full"
                        })
                    })
                ]
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StoresFilters);


/***/ }),

/***/ 53641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var StoresList = function(param) {
    var storesData = param.storesData, children = param.children;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        children: storesData.map(function(store, index) {
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                className: "".concat(index > 0 ? "border-t border-[#E6E6E6]" : "", " py-[20px]"),
                children: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(children, {
                    storeData: store
                })
            }, store.id);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (StoresList);


/***/ }),

/***/ 19626:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var filterStores = function(param) {
    var _storesData = param.storesData, storesData = _storesData === void 0 ? [] : _storesData, regionId = param.regionId, storeName = param.storeName;
    var newFilteredStores = _toConsumableArray(storesData);
    if (regionId) {
        newFilteredStores = newFilteredStores.filter(function(store) {
            return store.region_id === Number(regionId);
        });
    }
    if (storeName) {
        newFilteredStores = newFilteredStores.filter(function(store) {
            return store.name.toLowerCase().includes(storeName.toLowerCase());
        });
    }
    return newFilteredStores;
};
/* harmony default export */ __webpack_exports__["Z"] = (filterStores);


/***/ }),

/***/ 35254:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var sortedStores = function(param) {
    var _storesData = param.storesData, storesData = _storesData === void 0 ? [] : _storesData, stickyStore = param.stickyStore;
    if (!storesData.length || !stickyStore) return storesData;
    var selectedStoreId = stickyStore.id;
    // Check if the selected store exists in the stores data
    var selectedStoreHasStock = storesData.some(function(store) {
        return store.id === selectedStoreId;
    });
    if (!selectedStoreHasStock) return storesData;
    // Filter out the selected store and move it to the top
    return [
        stickyStore, 
    ].concat(_toConsumableArray(storesData.filter(function(store) {
        return store.id !== selectedStoreId;
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (sortedStores);


/***/ })

}]);